import { Alert, Box, Button, Flex, Stack, Switch, Text, useToast } from '@chakra-ui/react';
import React from 'react';
import { useSaveToClipBoard } from '../../../hooks';
import { useApolloClient, useMutation } from '@apollo/client';
import { TerminateCallAction } from '../../../graphql/mutations/TerminateCallAction';
import { useError } from '../../../error-provider/ErrorProvider';

const TerminateCallActions = ({ data, agentId }) => {
    const toast = useToast();
    const { showError } = useError();

    const apolloClient = useApolloClient();

    const [onCallTransfer, { loading }] = useMutation(TerminateCallAction, {
        onError(error) {
            showError(undefined, error);
        },
    });

    const active = data?.active ?? false;
    const code = data?.code ?? '{end_call}';

    async function changeTransfer(isActive) {
        const variables = {
            active: isActive,
        };
        await onCallTransfer({
            variables: { ...variables, agentId: agentId },
            onCompleted(data) {
                if (data.terminateCallAction.__typename === 'SuccessType') {
                    toast({
                        status: 'success',
                        isClosable: true,
                        title: data.terminateCallAction.message,
                    });

                    apolloClient.cache.modify({
                        id: `AgentType:${agentId}`,
                        fields: {
                            terminateCallAction() {
                                return variables;
                            },
                        },
                    });
                } else {
                    toast({
                        status: 'error',
                        isClosable: true,
                        title: data.terminateCallAction.message,
                    });
                }
            },
        });
    }

    const saveInClipBoard = useSaveToClipBoard(code, toast, 'Example');
    return (
        <Box>
            <Flex
                fontSize={{ base: '24px', sm: '28px' }}
                lineHeight='28px'
                fontWeight={{ base: '400', sm: '700' }}
                textAlign='left'
                gap='10px'
                alignItems='center'
                mb='10px'
            >
                <Stack direction='row' alignItems='center'>
                    <Switch
                        isDisabled={loading}
                        isChecked={active}
                        onChange={() => changeTransfer(!active)}
                        colorScheme='blackAlpha'
                    />
                    <Stack spacing='0'>
                        <Text fontSize='md'>Let Agent Terminate Calls</Text>
                        <Text fontSize='sm' color='#6b7280' fontWeight='300'>
                            Allow the AI agent to end calls when appropriate
                        </Text>
                    </Stack>
                </Stack>
            </Flex>
            {active && (
                <Stack spacing='12px' maxW='500px'>
                    <Box p='10px 0px'>
                        <Text fontWeight={{ base: '400', sm: '700' }}>End Call Token:</Text>
                        <Flex alignItems='center' justifyContent='space-between'>
                            <Text fontWeight={{ base: '400', sm: '700' }}>{code}</Text>
                            <Button onClick={saveInClipBoard}>Copy</Button>
                        </Flex>
                    </Box>
                    <Stack>
                        <Box>
                            <Alert fontSize='20px' color='#0039a6' borderLeft='5px solid #0039a6' bgColor='blue.100'>
                                {` Copy paste this token in your training guide along with instructions for when to use.
                                Example: When the caller says goodbye, ${code}`}
                            </Alert>
                        </Box>
                    </Stack>
                </Stack>
            )}
        </Box>
    );
};

export default TerminateCallActions;
